<template>
  <div class="content">
    <!-- start of search -->
    <div class="search-area">
      <el-row :gutter="24">
        <!-- 企业名称 -->
        <el-col :span="6">
          <div class="search-area-div">企业名称</div>
          <el-select size="mini" v-model="page.tenantGuid" placeholder="请选择药企名称" class="ipt-sty"
            @change="tenantChange" clearable filterable>
            <el-option v-for="item in tenantList" :key="item.guid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <!-- 组织名称 -->
        <el-col :span="6">
          <div class="search-area-div">组织名称</div>
          <el-select size="mini" v-model="page.organisationGuid" placeholder="请选择部门名称" class="ipt-sty"
            clearable filterable @focus="getOrganisation()">
            <el-option v-for="item in organisationList" :key="item.guid" :label="item.organisationName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <!-- 考核分类 -->
        <el-col :span="6">
          <div class="search-area-div">考核分类</div>
          <el-select size="mini" filterable v-model="page.evaluationContent" placeholder="请选择">
            <el-option v-for="(item, index) in assessmentClassification" :key="index" :label="item.evaluationContent"
              :value="item.evaluationContent"></el-option>
          </el-select>
        </el-col>
        <!-- search-btn -->
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="searchList">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- end of search -->

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <!-- start of add btn -->
      <div class="button-area">
        <el-button v-if="getBtnPermissionsByName('新增考核规则')" size="mini" type="info" @click="add">新增考核规则</el-button>
        <el-button v-if="getBtnPermissionsByName('批量复制')" size="mini" type="info" @click="toBulkCopy">批量复制</el-button>
      </div>
      <!-- end of add btn -->

      <!-- start of table -->
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="height" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column label="序号" width="50" header-align="center" align="center">
          <div slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </div>
        </el-table-column>
        
        <!-- 考核分类 -->
        <el-table-column prop="evaluationContent" width="120" label="考核分类" header-align="center" align="left">
          <template slot-scope="scope">
            <div v-if="!scope.row.isEdit">
              {{ scope.row.evaluationContent }}
            </div>
            <div v-else>
              <el-select size="mini" filterable v-model="scope.row.evaluationContent" placeholder="请选择" @change="handleSelectEval(scope.row.evaluationContent, scope.$index)">
                <el-option v-for="(item, index) in assessmentClassification" :key="index" :label="item.evaluationContent"
                  :value="item.evaluationContent"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <!-- 是否合格 -->
        <el-table-column prop="isPass" label="是否合格" width="120" header-align="center">
          <template slot-scope="scope">
            <div v-if="!scope.row.isEdit">
              <!-- P是部分合格，N是不合格 -->
              {{ scope.row.isPass == 'N' ? '不合格' : '部分合格' }}
            </div>
            <div v-else>
              <el-select size="mini" filterable v-model="scope.row.isPass" placeholder="请选择" @change="handleSelectIsPassList(scope.row, scope.$index)">
                <el-option v-for="(item, index) in isPassList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <!-- 平台规则定义 -->
        <el-table-column prop="taskEvaluationDetailDesc" show-overflow-tooltip label="平台规则定义" width="240" header-align="center" align="left">
          <template slot-scope="scope">
            <template v-if="!scope.row.isEdit">
              {{ scope.row.taskEvaluationDetailDesc }}
            </template>
            <template v-else>
              <el-select size="mini" filterable v-model="scope.row.taskEvaluationDetailDesc" placeholder="请选择" @change="changeTaskDesc(scope.row, scope.$index)">
                <el-option
                  v-for="(item, index) in scope.row.taskEvaluationList"
                  :key="index"
                  :label="item.evaluationRuleDesc"
                  :value="item.evaluationRuleDesc"
                >
                </el-option>
              </el-select>
            </template>
          </template>
        </el-table-column>
        <!-- 自定义规则定义 -->
        <el-table-column prop="customRuleDesc" label="自定义规则定义" width="240" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">
            <template v-if="!scope.row.isEdit">
              {{ scope.row.customRuleDesc }}
            </template>
            <template v-else>
              <el-input size="mini" v-model="scope.row.customRuleDesc" placeholder="请输入"></el-input>
            </template>
          </template>
        </el-table-column>
        <!-- 扣罚比例 -->
        <el-table-column prop="customCutRate" width="100" label="扣罚比例" header-align="center" align="right">
          <template slot-scope="scope">
            <div v-if="!scope.row.isEdit">
              {{ scope.row.customCutRate }} %
            </div>
            <div v-else>
              <div class="rate-box">
                <el-input size="mini" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" v-model="scope.row.customCutRate" placeholder="请输入"></el-input>
                <span> %</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 适用项目 -->
        <el-table-column prop="tenantName" show-overflow-tooltip width="180" label="适用项目" header-align="center" align="left">
          <template slot-scope="scope">
            <div v-if="!scope.row.isEdit">
              {{ scope.row.tenantName }}
            </div>
            <div v-else>
              <el-select size="mini" v-model="scope.row.tenantGuid" placeholder="请选择适用项目"
                @change="tenantRowChange(scope.row, scope.$index)" filterable>
                <el-option v-for="item in tenantList" :key="item.guid" :label="item.sendTenantName"
                  :value="item.sendTenantGuid">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <!-- 适用组织 -->
        <el-table-column prop="organisationName" show-overflow-tooltip min-width="140" label="适用组织" header-align="center" align="left">
          <template slot-scope="scope">
            <div v-if="!scope.row.isEdit">
              {{ scope.row.organisationName }}
            </div>
            <div v-else>
              <el-select size="mini" v-model="scope.row.organisationGuid" placeholder="请选择适用组织"
                clearable filterable @focus="getRowOrganisation(scope.row)" @change="changeRowOrg(scope.row, scope.$index)">
                <el-option v-for="item in scope.row.organisationList" :key="item.guid" :label="item.organisationName"
                  :value="item.guid">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <!-- 规则标签 -->
        <!-- <el-table-column label="规则标签" header-align="center" align="center" width="140">
          <template slot-scope="scope">
            <div v-if="!scope.row.isEdit">
              {{ scope.row.ruleTag | commonFilterName('规则标签') }}
            </div>
            <div v-else>
              <el-select size="mini" filterable v-model="scope.row.ruleTag" placeholder="请选择">
                <el-option
                  v-for="(item, index) in getCodeListByKey('规则标签')"
                  :key="index"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column width="140px" label="操作" header-align="center" align="center" v-if="getBtnPermissionsByName('复制') || getBtnPermissionsByName('编辑') || getBtnPermissionsByName('删除')">
          <template slot-scope="scope">
            <div v-if="scope.row.isEdit">
              <el-button type="text" size="mini" @click="saveData(scope.row, scope.$index)">保存</el-button>
              <!-- 有guid的话，直接还原状态 -->
              <el-button v-if="scope.row.guid" type="text" size="mini" @click="cannel(scope.row, scope.$index)">取消</el-button>
              <!-- 没有guid的话，需要将此行的数据移除 -->
              <el-button v-else type="text" size="mini" @click="del(scope.$index)">取消</el-button>
            </div>
            <div v-else>
              <el-button v-if="getBtnPermissionsByName('复制')" type="text" size="mini" @click="toCopy(scope.row, scope.$index)">复制</el-button>
              <el-button v-if="getBtnPermissionsByName('编辑')" type="text" size="mini" @click="edit(scope.row, scope.$index)">编辑</el-button>
              <el-button v-if="getBtnPermissionsByName('删除')" type="text" size="mini" @click="delData(scope.row.guid)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- end of table -->
    </div>

    <!-- start of pagination -->
    <el-pagination class=" pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <!-- end of pagination -->

    <!-- 复制弹框 -->
    <el-dialog :title="'复制考核机制'" :visible.sync="dialogCheckVisible" width="500px">
      <div slot="title" class="dialog-title">
        {{ '复制考核规则' }}
      </div>
      <div class="dialogCon">
        <!-- 原因说明 -->
        <div class="dialogCon-describe">
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="import_new_wrap">
                <div class="import-dialog-title">
                  <img src="../../assets/icon/import_warning.png" alt="" />说明: 该功能支持批量复制规则给其他药企
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="search-area-div">{{ `已选择规则: ${multipleSelection.length}条` }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" style="display:flex">
              <div class="search-area-div">{{ '应用项目:' }}</div>
              <el-select style="width:398px" v-model="tenantGuids" clearable multiple reserve-keyword filterable placeholder="请选择">
                <el-option v-for="item in tenantList" :label="item.sendTenantName" :value="item.sendTenantGuid" :key="item.guid">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 内层dialog -->
      <el-dialog
        width="500px"
        title="特别提醒"
        :visible.sync="innerVisible"
        append-to-body>
        <div class="dialogCon">
          <!-- 原因说明 -->
          <div class="dialogCon-describe">
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="import_new_wrap">
                  <div class="import-dialog-title">
                    <img src="../../assets/icon/import_warning.png" alt="" />以下规则已存在，确定覆盖吗?
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="content-main-box">
              <el-table :data="ruleList" stripe border max-height="400" style="width: 100%">
                <el-table-column 
                  prop="col1"
                  label="应用项目"
                  show-overflow-tooltip
                  header-align="left"
                  align="left"
                  width="180"
                > 
                </el-table-column>
                <el-table-column
                  prop="col2"
                  label="规则名称"
                  show-overflow-tooltip
                  header-align="left"
                  align="left"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="innerVisible = false">取消</el-button>
          <el-button type="info" size="small" @click="toCopyPromise">确定</el-button>
        </span>
      </el-dialog>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" v-loading.fullscreen.lock="fullscreenLoading" type="info" @click="submit2">复 制</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import btnPermisson from '../mixins/btnPermisson';
import { cloneDeep } from 'lodash';
export default {
  mixins:[btnPermisson],
  data() {
    return {
      tenantGuids: [],
      height: window.innerHeight - 260,
      contentMainHeight: window.innerHeight - 200,
      tableLoading: false,
      fullscreenLoading: false,
      dialogCheckVisible:false,
      innerVisible:false, // 内层dialog
      ruleList:[],
      multipleSelection:[],
      page: {
        pageIndex: 1,
        pageSize: 50,
        tenantGuid: '',
        organisationGuid: '',
        evaluationContent: '',
        curTenantGuid: localStorage.guid
      },
      // 是否合格下拉选项
      isPassList: [
        // { label: '合格', value: 'Y' },
        { label: '部分合格', value: 'P' },
        { label: '不合格', value: 'N' },
      ],
      // 考核分类下拉选项，例：拍照要求、打卡要求、上传资料、系统录入
      assessmentClassification: [],
      tableData: [],
      // 药企数据
      tenantList: [],
      // 组织数据
      organisationList: [],

    };
  },
  created() {
    this.getList();
    // 获取药企数据
    this.getTenantList();
    // 获取考核分类数据
    this.getEvaluationList();
    // 获取按钮权限
    this.getMenuList()
  },
  watch: {
    dialogCheckVisible() {
      this.tenantGuids = []
    }
  },
  methods: {
    // todo 批量复制
    toBulkCopy() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请先勾选数据');
        return
      }
      let one = this.multipleSelection[0]
      if (!this.multipleSelection.every(item=>item.tenantGuid === one.tenantGuid)) {
        this.$message.warning('请选择同一药企的规则');
        return
      }
      this.dialogCheckVisible = true
    },
    // 复制
    toCopy(row) {
      let copyData = JSON.parse(JSON.stringify((row)))
      copyData.isEdit = true
      copyData.guid = ''
      copyData.tenantName = ''
      copyData.tenantGuid = ''
      copyData.organisationName = ''
      copyData.organisationGuid = ''
      this.tableData.unshift(copyData)
    },
    // todo 确认复制
    submit() {
      if (!this.tenantGuids.length) {
        this.$message.warning('请选择药企');
        return
      }
      let param = {
        sourceTenantGuid:this.multipleSelection[0].tenantGuid, // 源企业
        targetTenantGuidList:this.tenantGuids, // 目标企业
        ruleGuidList:this.multipleSelection.map(item=>item.guid) // 
      }
      this.fullscreenLoading = true
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/detail/copy-org-detail`, param).then((res) => {
        this.fullscreenLoading = false
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (Array.isArray(res.data.data) && res.data.data.length) {
            this.innerVisible = true
            this.ruleList = res.data.data
            return
          }
          this.$message.success('复制成功');
          this.dialogCheckVisible = false;
          this.searchList()
        } else {
          this.innerVisible = true
          this.$message.error(res.data.msg);
        }
      });
    },
    // todo 确认复制
    async submit2() {
      this.ruleList = []
      if (!this.tenantGuids.length) {
        this.$message.warning('请选择药企');
        return
      }
      let param = {
        sourceTenantGuid:this.multipleSelection[0].tenantGuid, // 源企业
        targetTenantGuidList:this.tenantGuids, // 目标企业
        ruleGuidList:this.multipleSelection.map(item=>item.guid) // 
      }
      this.fullscreenLoading = true
      await this.getOrgRepeatInfoPromise(param)
      if (this.ruleList.length) {
        this.innerVisible = true
      } else {
        this.toCopyPromise()
      }
    },
    // 获取项目重复规则服务
    getOrgRepeatInfoPromise(param) {
      return new Promise((resolve,reject)=>{
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/detail/get-org-repeat-info`, param).then((res) => {
          this.fullscreenLoading = false
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (Array.isArray(res.data.data) && res.data.data.length) {
              this.innerVisible = true
              this.ruleList = res.data.data
              resolve(res.data.data)
            } else {
              this.ruleList = []
              resolve([])
            }
          }
        });
      })
    },
    // 复制服务
    toCopyPromise() {
      let param = {
        sourceTenantGuid:this.multipleSelection[0].tenantGuid, // 源企业
        targetTenantGuidList:this.tenantGuids, // 目标企业
        ruleGuidList:this.multipleSelection.map(item=>item.guid) // 
      }
      return new Promise((res,rej)=>{
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/detail/copy-org-detail`, param).then((res) => {
          this.fullscreenLoading = false
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              this.$message.success('复制成功');
              this.innerVisible = false
              this.dialogCheckVisible = false;
              this.searchList()
            }
            res(res.data.data) // 返回boolean
          }
        });
      })
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    searchList() {
      this.page['pageIndex'] = 1;
      this.getList();
    },
    // 清空
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        tenantGuid: "",
        organisationGuid: '',
        evaluationContent: '',
        curTenantGuid: localStorage.guid
      };
      this.getList();
    },
    // 获取列表数据
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/get-list-org`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let records = res.data.data.records || [];
          records.forEach((item, index) => {
            // 表示是否是编辑,获取的列表数据默认是false
            item.isEdit = false;
          })
          
          self.tableData = records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 新增
    add() {
      this.tableData.unshift({
        isEdit: true, // 表示是否是编辑,新增的时候默认是true
        evaluationContent: '', // 考核分类
        isPass: '', // 是否合格
        taskEvaluationDetailDesc: '', // 平台规则定义
        customRuleDesc: '', // 自定义规则定义
        customCutRate: '', // 扣罚比例
        tenantName: '', // 适用项目
        organisationName: '', // 适用组织
        organisationGuid: '',
        //ruleTag:'', // 规则标签
        organisationList: [], // 组织下拉选的数据是空的
        taskEvaluationList: [] // 平台规则定义下拉选数据是空的
      })
    },
    // 保存数据
    saveData(row, index) {
      
      console.log(row);
      var self = this;
      if (!row.evaluationContent) {
        return self.$message.error('请选择考核分类');
      }
      if (!row.isPass) {
        return self.$message.error('请选择是否合格');
      }
      if (!row.customRuleDesc) {
        return self.$message.error('请输入自定义规则定义');
      }
      if (!row.customCutRate) {
        return self.$message.error('请输入扣罚比例');
      }
      if (!row.tenantGuid) {
        return self.$message.error('请选择适用项目');
      }
      if (!row.organisationGuid) {
        return self.$message.error('请选择适用组织');
      }
      let organisationList = row.organisationList || [];
      let taskEvaluationList = row.taskEvaluationList || [];
      let oldData = row.oldData || [];

      delete row.organisationList; // 传值给后台的时候，将组织下拉选的数据过滤掉
      delete row.taskEvaluationList; // 传值给后台的时候，将平台定义规则下拉选的数据过滤掉

      if(row.oldData) {
        delete row.oldData; // 传值给后台的时候，将存放的旧数据过滤掉
      }
      
      var req = {
        ...row,
        // curTenantGuid: localStorage.guid
      };
      this.fullscreenLoading = true
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/edit-org`, req)
      .then((res) => {
        this.fullscreenLoading = false
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // 保存成功后，将此行变为不可编辑的状态
          self.tableData[index]['isEdit'] = false;
          self.tableData[index]['guid'] = res.data.data;
          self.$message.success('保存成功');
        } else {
          self.tableData[index]['organisationList'] = organisationList;
          self.tableData[index]['taskEvaluationList'] = taskEvaluationList;
          self.tableData[index]['oldData'] = oldData;

          self.$message.error(res.data.msg);
        }
      }).catch(error => {
        this.fullscreenLoading = false
        self.tableData[index]['organisationList'] = organisationList;
        self.tableData[index]['taskEvaluationList'] = taskEvaluationList;
        self.tableData[index]['oldData'] = oldData;
      });
    },
    // 修改
    edit(item, index) {
      let self = this;
      if(!self.tableData[index]['oldData']) {
        self.tableData[index]['oldData'] = JSON.parse(JSON.stringify(item));
      }
      let taskEvaluationGuid;
      this.assessmentClassification.forEach(el => {
        if(el.evaluationContent == item.evaluationContent) {
        //   选择考核机制后,给单行的数据添加指定机制的guid,方便获取对应的平台规则
           taskEvaluationGuid = el.guid;
        }
      })
      // 获取单行的平台规则定义下拉选数据
      self.getTaskDesc(item.isPass, taskEvaluationGuid, function(resp) {
        self.tableData[index]['taskEvaluationList'] = resp.data.records || [];

        // 给每一行的数据添加对应的组织下拉选数据
        self.getRowOrgData(item.tenantGuid, function(res) {
          // 重新给单行的组织下拉选数据赋值
          self.tableData[index]['organisationList'] = res.data.records;

          // 所有的下拉选数据都赋值成功了后，再进行编辑
          self.tableData[index]['isEdit'] = true;
          // console.log(self.tableData[index]['isEdit'])
          self.tableData = JSON.parse(JSON.stringify(self.tableData))
        });
      })
      
    },
    /**
     * 有guid的时候，点取消是还原数据
     * @param {*} item 
     * @param {*} index 
     */
    cannel(item, index) {
      this.tableData[index]['isEdit'] = false;
      this.tableData[index] = item['oldData'];
    },
    // 新增的时候，点取消是移除数据
    del(index) {
      this.tableData.splice(index, 1);
    },
    // 删除数据
    delData(guid) {
      var self = this;
      self.$confirm('删除后不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/delete-org`, [guid]).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功');
            self.page.pageIndex = 1;
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    /**
     * 获取考核分类数据
     */
    getEvaluationList() {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/list`, {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: localStorage.guid
      }).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // 给考核下拉选赋值
          self.assessmentClassification = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 选择考核分类
     * @param {*} val 
     * @param {*} index 
     */
    handleSelectEval(val, index) {
      this.tableData[index]['taskEvaluationDetailDesc'] = null;
      this.tableData[index]['isPass'] = null;
      this.tableData[index]['taskEvaluationList'] = [];
      this.assessmentClassification.forEach(item => {
        if(item.evaluationContent == val) {
          // 选择考核机制后,给单行的数据添加指定机制的guid,方便获取对应的平台规则
          this.tableData[index]['taskEvaluationGuid'] = item.guid;
        }
      })
    },
    /**
     * 选择是否合格的时候，需要将平台规则带出来
     * @param {*} row 
     * @param {*} index 
     */
    handleSelectIsPassList(row, index) {
      console.log(row);
      let self = this;
      let taskEvaluationGuid;
      this.assessmentClassification.forEach(el => {
        if(el.evaluationContent == row.evaluationContent) {
        //   选择考核机制后,给单行的数据添加指定机制的guid,方便获取对应的平台规则
          taskEvaluationGuid = el.guid;
        }
      })
      self.getTaskDesc(row.isPass, taskEvaluationGuid, function(res) {
        self.tableData[index]['taskEvaluationDetailDesc'] = null;
        self.tableData[index]['customRuleDesc'] = '';
        self.tableData[index]['customCutRate'] = '';

        // 重新给单行的平台规则定义下拉选数据赋值
        self.tableData[index]['taskEvaluationList'] = res.data.records || [];
      })
    },
    /**
     * 选择平台规则的时候，需要给自定义规则赋值
     * @param {*} row 
     * @param {*} index 
     */
    changeTaskDesc(row, index) {
      this.tableData[index]['customRuleDesc'] = row.taskEvaluationDetailDesc;
      let taskEvaluationList = this.tableData[index]['taskEvaluationList'] || [];
      taskEvaluationList.forEach(item => {
        if(item.evaluationRuleDesc == row.taskEvaluationDetailDesc) {
          this.tableData[index]['customCutRate'] = item.cutRate;
         this.tableData[index]['taskEvaluationDetailGuid'] = item.guid;
        }
      })
    },
    /**
     * 获取自定义平台规则
     * @param {*} isPass 
     * @param {*} taskEvaluationGuid 
     */
    getTaskDesc(isPass, taskEvaluationGuid, callback) {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        isPass: isPass,
        taskEvaluationGuid: taskEvaluationGuid,
        // tenantGuid: localStorage.guid
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(callback) callback(res.data);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 获取药企数据
    getTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api.get(
        `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 选择药企后，获取对应的组织数据
    tenantChange(val) {
      if (val) {
        this.getOrganisationList(val)
      }
    },
    // 获取组织数据
    getOrganisationList(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 条件搜索选择时，选择组织的时候，需要先选择药企
    getOrganisation() {
      if (!this.page.tenantGuid) {
        return this.$message.error('请先选择药企，再选择组织');
      }
    },
    // 某行数据选择药企的时候，需要获取单行的组织数据
    tenantRowChange(row, index) {
      let self = this;
      this.getRowOrgData(row.tenantGuid, function(res) {
        self.tableData[index]['organisationGuid'] = ''; // 清空组织旧数据
        self.tableData[index]['organisationList'] = res.data.records; // 重新给单行的组织下拉选数据赋值
        self.tableData = [...self.tableData]
      })

      const tenantName = this.tenantList.find(item => item.sendTenantGuid === row.tenantGuid).sendTenantName;
      this.tableData[index]['tenantName'] = tenantName;
    },
    changeRowOrg(row, index) {
      const organisationName = row.organisationList.find(item => item.guid === row.organisationGuid).organisationName;
      this.tableData[index]['organisationName'] = organisationName;
    },
    getRowOrgData(tenantGuid, callback) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: tenantGuid,
        sendTenantGuid: localStorage.guid
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(callback) callback(res.data)
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 选择组织的时候，需要先选择药企
    getRowOrganisation(row) {
      if (!row.tenantGuid) {
        return this.$message.error('请先选择药企，再选择组织');
      }
    },
    // 修改size
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    // 修改index
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val || 1;
      this.getList();
    },
  },
};
</script> 
<style lang="less" scoped>
.el-table /deep/ .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.check-table-input .el-input__inner {
  text-align: right !important;
}
.rate-box {
 display: flex;
 align-items: center;
 justify-content: space-around;
 .el-input {
  width: 85%;
 }
}
/* 弹框样式 */
/deep/.el-dialog__footer {
  padding: 10px 20px 10px;
  border-top: 1px solid #d9d9d9;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 10px 15px;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.dialogCon {
  border-top: 1px solid #dcdee0;
  text-align: left;
  padding: 10px 20px;
}
.content-main-box {
  padding-top: 10px;
  height: 100%;
}
.import_new_wrap {
  padding: 0;
  border: 0;
}
</style>